import { Link } from 'react-router-dom';
import { footer, contact, nav, social } from '../../content/agencyCopy';

// A social link that 404s costs more trust than no social link at all, so
// placeholder entries are dropped rather than rendered.
const liveSocial = social.filter((s) => !s.href.includes('REPLACE'));

export default function AgencyFooter() {
  return (
    <footer
      className="mt-24"
      style={{ borderTop: '1px solid var(--fa-rule)', background: 'var(--fa-paper)' }}
    >
      <div className="max-w-[1120px] mx-auto px-6 py-16 grid gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5">
        <div>
          <div className="font-display font-bold text-[18px]" style={{ color: 'var(--fa-ink)' }}>
            {nav.brand}
          </div>
          <div className="fa-label mt-3">{footer.tagline}</div>
        </div>

        <div>
          <div className="fa-label mb-4">Products</div>
          <ul className="space-y-2">
            {footer.productLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-[14px]"
                  style={{ color: 'var(--fa-ink)' }}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="fa-label mb-4">Contact</div>
          <ul className="space-y-2.5 text-[14px]" style={{ color: 'var(--fa-ink)' }}>
            {contact.inboxes.map((i) => (
              <li key={i.address} className="flex flex-col">
                <span className="fa-ref" style={{ fontSize: 8.5 }}>{i.label}</span>
                <a href={`mailto:${i.address}`} style={{ color: 'var(--fa-ink)' }}>
                  {i.address}
                </a>
              </li>
            ))}
            <li className="pt-1">
              <a
                href={contact.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: 'var(--fa-ink)' }}
              >
                WhatsApp
              </a>
            </li>
          </ul>
        </div>

        {liveSocial.length > 0 && (
          <div>
            <div className="fa-label mb-4">Elsewhere</div>
            <ul className="space-y-2">
              {liveSocial.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[14px] inline-flex items-center gap-1.5"
                    style={{ color: 'var(--fa-ink)' }}
                  >
                    {s.label}
                    <span aria-hidden="true" style={{ color: 'var(--fa-signal)' }}>↗</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div>
          <div className="fa-label mb-4">Legal</div>
          <ul className="space-y-2">
            {footer.legalLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className="text-[14px]"
                  style={{ color: 'var(--fa-ink)' }}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div
        className="border-t"
        style={{ borderColor: 'var(--fa-rule)' }}
      >
        <div
          className="max-w-[1120px] mx-auto px-6 py-6 text-[12px]"
          style={{ color: 'var(--fa-muted)' }}
        >
          © {new Date().getFullYear()} FRONTECH Consulting.
        </div>
      </div>
    </footer>
  );
}
